var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Form, notification } from 'antd';
// @ts-ignore
import Button from '@fp-suite/core-ui/src/components/Button';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultScale, getDefaultScale, getScaleList, userSelector } from '../redux/authSlice';
import { useTranslation } from 'react-i18next';
var ScalePreference = function (_a) {
    var setIsLoading = _a.setIsLoading, _b = _a.hostname, hostname = _b === void 0 ? null : _b, refreshQzHostname = _a.refreshQzHostname;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var form = Form.useForm()[0];
    var _c = useState(''), scale = _c[0], setScale = _c[1];
    var scaleList = useSelector(userSelector).scaleList;
    useEffect(function () {
        var loadDefaultScale = function () { return __awaiter(void 0, void 0, void 0, function () {
            var currentHostname, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!refreshQzHostname) return [3 /*break*/, 2];
                        return [4 /*yield*/, refreshQzHostname(false)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = hostname;
                        _b.label = 3;
                    case 3:
                        currentHostname = _a;
                        dispatch(getDefaultScale({ setScale: setScale, hostname: currentHostname }));
                        return [2 /*return*/];
                }
            });
        }); };
        loadDefaultScale();
    }, [dispatch, hostname, refreshQzHostname]);
    useEffect(function () {
        dispatch(getScaleList());
    }, [dispatch]);
    useEffect(function () {
        if (!scaleList)
            return;
        var scaleExists = scaleList.some(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === scale; });
        form.setFieldsValue({
            scale_Id: scale && scaleExists ? scale : undefined
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scale, scaleList]);
    var setScaleId = function (scaleComputerId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentHostname, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoading(true);
                    form.setFieldsValue({ scaleComputerId: scaleComputerId });
                    if (!refreshQzHostname) return [3 /*break*/, 2];
                    return [4 /*yield*/, refreshQzHostname()];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = hostname;
                    _b.label = 3;
                case 3:
                    currentHostname = _a;
                    return [4 /*yield*/, dispatch(setDefaultScale({ scaleComputerId: scaleComputerId, hostname: currentHostname }))];
                case 4:
                    _b.sent();
                    setIsLoading(false);
                    return [2 /*return*/, { saved: true, hostname: currentHostname }];
            }
        });
    }); };
    var selectedScaleList = function (value) {
        setIsLoading(true);
        setScale(value);
        form.setFieldsValue({
            scale_Id: value
        });
        setIsLoading(false);
    };
    return (_jsx("div", __assign({ className: 'px-4 sm:px-8 lg:px-16 pt-1 lg:pt-3 pb-4 md:h-screen sm:h-auto w-full sm:w-4/5 md:w-3/5 lg:w-2/5' }, { children: _jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsx("h1", __assign({ className: 'font-bold text-base mb-7' }, { children: t('Set Scale Preference') }), void 0), _jsx("div", __assign({ className: 'w-11/12 mx-auto' }, { children: _jsxs(Form, __assign({ form: form, initialValues: { scale_Id: scale } }, { children: [_jsx(Form.Item, __assign({ name: 'scale_Id', rules: [{ required: true, message: t('Select the Scale!') }] }, { children: _jsx(Dropdown, { title: t('Select Scale'), placeholder: t('select scale'), data: scaleList, onChange: selectedScaleList }, void 0) }), void 0), _jsx(Form.Item, { children: _jsx("div", __assign({ className: 'flex flex-col' }, { children: _jsx(Button, { buttonText: t('Set'), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var _a, saved, sentHostname, scaleExists, hostnameMessage;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0: return [4 /*yield*/, setScaleId(scale)];
                                                    case 1:
                                                        _a = _b.sent(), saved = _a.saved, sentHostname = _a.hostname;
                                                        scaleExists = scaleList === null || scaleList === void 0 ? void 0 : scaleList.some(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === scale; });
                                                        if (saved && scaleExists) {
                                                            hostnameMessage = sentHostname
                                                                ? "Updated scale for computer: " + sentHostname + " and user."
                                                                : 'Updated scale for user not for computer.';
                                                            notification['success']({
                                                                message: t('Success'),
                                                                description: t('Successfully set default Scale!') + " " + hostnameMessage
                                                            });
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); } }, void 0) }), void 0) }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0));
};
export default ScalePreference;
